import React, { useEffect, useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import FlippingCardBackOverlay from './shared/backdropOverlay';
import FlippingCardFront from './shared/front';
import FlippingCardBack from './shared/back';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const FlippingCard = (props) => {
  const { sitecoreContext } = props;
  const { rendering } = props;
  const isEditing = sitecoreContext?.pageEditing;
  const { headerSize, contentAlignment, Styles, componentWidth } = props.params;
  const { heading, color, image, video } = props?.fields;
  const [flipped, setFlipped] = useState(false);
  const [noAnimation, setNoAnimation] = useState(true);
  // No back placeholders logic
  const placeholders = rendering?.placeholders;
  const jssFpBack = placeholders['jss-fp-back'];
  const jssFpBackRight = placeholders['jss-fp-back-right'];
  const showBack =
    jssFpBack.length > 0 ||
    (componentWidth === '1120' && (jssFpBackRight.length > 0 || jssFpBack.length > 0));

  const handleFlip = () => {
    showBack && setFlipped((prev) => !prev);
  };

  const unFlip = () => setFlipped(false);

  useEffect(() => {
    setTimeout(() => setNoAnimation(false), 400);
  }, []);

  if (!props?.fields || !props.params) return <GenericPlaceholder componentName="FlippingCard" />;
  return isEditing ? (
    <div className="placeholders-wrapper" style={{ position: 'relative', zIndex: '1' }}>
      <div className="placeholder-front">
        <Placeholder name="jss-fp-front" rendering={rendering} sub={true} />
      </div>
      {componentWidth === '1120' && (
        <div className="placeholder-front-right" style={{ position: 'relative', zIndex: '1' }}>
          <Placeholder name="jss-fp-front-right" rendering={rendering} />
        </div>
      )}
      <div className="placeholder-back" style={{ position: 'relative', zIndex: '1' }}>
        <Placeholder name="jss-fp-back" rendering={rendering} sub={true} />
      </div>
      {componentWidth === '1120' && (
        <div className="placeholder-back-right" style={{ position: 'relative', zIndex: '1' }}>
          <Placeholder name="jss-fp-back-right" rendering={rendering} />
        </div>
      )}
    </div>
  ) : (
    <div
      className={clsx(
        'flipping-card',
        isEditing && 'editing',
        'add-margins',
        Styles,
        componentWidth === '1120' && 'big-var content',
        !showBack && 'no-back'
      )}
    >
      <FlippingCardBackOverlay visible={flipped} hide={unFlip} />
      <div className={clsx('fc-wrapper', flipped && 'fc-wrapper-flipped')}>
        <div className="fc-card">
          <FlippingCardFront
            handleFlip={handleFlip}
            heading={heading}
            rendering={rendering}
            componentWidth={componentWidth}
            className={clsx(
              'fc-card-side',
              flipped && !isEditing ? 'fc-card-side-inactive' : 'fc-card-side-active',
              noAnimation && 'no-animation'
            )}
            iconClassName="fc-card-icon"
            background={{ color, image, video }}
            headerSize={headerSize}
            align={contentAlignment}
            isEditing={isEditing}
            showBack={showBack}
          />
          <FlippingCardBack
            handleFlip={handleFlip}
            rendering={rendering}
            componentWidth={componentWidth}
            className={clsx(
              'fc-card-side',
              flipped || isEditing ? 'fc-card-side-active' : 'fc-card-side-inactive',
              noAnimation && 'no-animation'
            )}
            iconClassName="fc-card-icon"
            isEditing={isEditing}
            showBack={showBack}
          />
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(FlippingCard);
